// extracted by mini-css-extract-plugin
module.exports = {"container":"EditContactModale_container__3ncpj","list":"EditContactModale_list__ka72W","card":"EditContactModale_card__1FNY7"};